import { render } from "./TwilioCallback.vue?vue&type=template&id=5d837d83&ts=true"
import script from "./TwilioCallback.vue?vue&type=script&lang=ts"
export * from "./TwilioCallback.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__